import { render, staticRenderFns } from "./RecommendationInsights.vue?vue&type=template&id=4e765819"
import script from "./RecommendationInsights.vue?vue&type=script&lang=js"
export * from "./RecommendationInsights.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports